module.exports = __webpack_public_path__ + "img/bg_espace_rc_mini.f729a05c.jpg";